"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _AccessControlTranslation_1 = require("./_AccessControlTranslation");
var _EncryptionConfiguration_1 = require("./_EncryptionConfiguration");
exports._Destination = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            }
        },
        Account: {
            shape: {
                type: "string"
            }
        },
        StorageClass: {
            shape: {
                type: "string"
            }
        },
        AccessControlTranslation: {
            shape: _AccessControlTranslation_1._AccessControlTranslation
        },
        EncryptionConfiguration: {
            shape: _EncryptionConfiguration_1._EncryptionConfiguration
        }
    }
};
//# sourceMappingURL=_Destination.js.map